module.exports = __webpack_public_path__ + "img/logoFacebook.e0e62a28.svg";